export const MODIFY_PAYMENT_MODAL_ORIGIN = 'MODIFY_PAYMENT_MODAL_ORIGIN';

export function modifyPaymentModalOrigin(paymentModalOrigin){
    return{
        type: MODIFY_PAYMENT_MODAL_ORIGIN,
        mainState: {
            paymentModalOrigin: paymentModalOrigin
        }
    }
}